export { default as RegistrationSelect } from './RegistrationSelect';



// WEBPACK FOOTER //
// ./src/components/FormControls/RegistrationSelect/index.ts